import classNames from 'classnames';
import React from 'react';
import Button from '../../components/Button';
import OpacityMotionTransition from '../../components/OpacityMotionTransition';
import OverflowMenu from '../../components/OverflowMenu';
import SVGIcon from '../../components/SVGIcon';
import overflowMenuIcon from '../../icons/non-prefilled/16x16/overflowMenu.svg';
import * as styles from './MagneticWallItemOverflowMenu.module.scss';

interface CommentButtonProps {
  active?: boolean;
  icon?: string;
  onClick?: () => void;
  ariaLabel?: string;
}

export const MagneticWallOverflowButton = ({
  active,
  icon,
  onClick,
  ariaLabel,
}: CommentButtonProps) => (
  <Button
    className={classNames(styles.button, { [styles.active]: active })}
    onClick={onClick}
    aria-label={ariaLabel}
  >
    <SVGIcon size={14}>{icon}</SVGIcon>
  </Button>
);

export const isClickingMagneticWallItemOverflowButton = (event: MouseEvent) =>
  CLICK_EVENTS.has(event);

interface MagneticWallItemOverflowMenuProps {
  menuItems?: React.ReactNode[];
  children?: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const CLICK_EVENTS = new WeakSet<MouseEvent>();

const MagneticWallItemOverflowMenu = ({
  menuItems,
  children,
  open,
  onOpenChange,
}: MagneticWallItemOverflowMenuProps) => {
  return (
    <OpacityMotionTransition
      className={styles.container}
      onClick={(e) => {
        // prevents the click listener from the MagneticWallItem from firing
        // so the comment buttons can be clicked without expanding the MagneticWallItem
        CLICK_EVENTS.add(e.nativeEvent);
      }}
    >
      {children}
      {menuItems && menuItems.length > 0 && (
        <OverflowMenu
          inline={false}
          open={open}
          onOpenChange={onOpenChange}
          button={
            <Button
              aria-label="More options"
              className={classNames(styles.button, {
                [styles.active]: open,
              })}
            >
              <SVGIcon size={14}>{overflowMenuIcon}</SVGIcon>
            </Button>
          }
        >
          {menuItems}
        </OverflowMenu>
      )}
    </OpacityMotionTransition>
  );
};

export default MagneticWallItemOverflowMenu;
